<template>
    <div class="mt-3">
<!-- {{CBCWorkList}} -->

        <b-loading  :active.sync="isFullScreenLoading" ></b-loading>
<!-- {{selected}} -->
 
        <b-tabs type="is-boxed" ref="tabMain"  v-model="tabMain" >


<!--            Tab WorkList   -->
            <b-tab-item  label="Work List" icon="playlist-play">
             <div  @keyup.enter="doFilter">

 

                 <div>
                 <nav class="level is-mobile" >
                     <div class="level-left " >
                         <div class="level-item ">
                                 <b-field label="Date Kind">
                                     <b-select placeholder="Select Date Kind" v-model="filter_dateKindsSelectedModel">
                                         <option
                                                 v-for="dateKind in dateKinds"
                                                 :value="dateKind.id"
                                                 :key="dateKind.id">
                                             {{ dateKind.name }}
                                         </option>
                                     </b-select>
                                 </b-field>
                         </div>
                         <!--v-model="date_selectedStart"  -->
                         <div class="level-item ">
                                 <b-field label="Start Date">
                                     <b-datepicker
                                             :date-formatter="dateFormatterForDatePicker"
                                             v-model="filter_date_selected_startModel"
                                             placeholder="Start Date..."
                                             icon="calendar-today"
                                     >
                                     </b-datepicker>
                                     <b-tooltip label="Set Today" position="is-top">
                                     <p class="control">
                                         <b-button type="is-success" icon-left="close"  outlined  @click="clearSomeField('date_selected_start')"/>
                                     </p>
                                     </b-tooltip>
                                 </b-field>
                         </div>
                         <!--  v-model="date_selectedDue"  -->
                         <div class="level-item ">
                                 <b-field label="Due Date">
                                     <b-datepicker
                                             :date-formatter="dateFormatterForDatePicker"
                                             v-model="filter_date_selected_endModel"
                                             placeholder="Due Date..."
                                             icon="calendar-today"

                                     >
                                     </b-datepicker>
                                     <b-tooltip label="Set Today" position="is-top">
                                         <p class="control">
                                             <b-button type="is-success" icon-left="close"  outlined  id="btnClear1" @click="clearSomeField('date_selected_due')" />
                                         </p>
                                     </b-tooltip>
                                 </b-field>
                         </div>
                         <div class="level-item ">
                                 <b-field label="OPD No.">
                                     <b-input   v-model="filter_opdnoModel" ></b-input>
                                     <!-- <b-input  :value="filter_selected.opdno" @change.native="filter_selected.opdno = $event.target.value"  ref="filter_selectedopdno"></b-input> -->
                                     <b-tooltip label="Clear OPD No." position="is-top">
                                         <p class="control">
                                             <b-button type="is-success" icon-left="close"  outlined  id="btnClear2" @click="setFilter_opdno('') "   />
                                         </p>
                                     </b-tooltip>
                                 </b-field>
                         </div>
                         <div class="level-item ">
                                 <b-field label="Pet Name">
                                     <!-- <b-input :value="filter_selected.opdname" @change.native="filter_selected.opdname = $event.target.value"  ref="filter_selectedopdname"  ></b-input> -->
                                     <b-input v-model="filter_opdnameModel"  ></b-input>
                                     <b-tooltip label="Clear Pet Name" position="is-top">
                                         <p class="control">
                                             <b-button type="is-success" icon-left="close"  outlined  id="btnClear3"  @click=" setFilter_opdname('') "/>
                                         </p>
                                     </b-tooltip>
                                 </b-field>
                         </div>
                         <div class="level-item ">
                                 <b-field label="Owner Name">
                                     <!-- <b-input :value="filter_selected.ownername" @change.native="filter_selected.ownername = $event.target.value" ></b-input>  -->
                                     <b-input v-model="filter_ownernameModel" ></b-input>
                                     <b-tooltip label="Clear Owner Name" position="is-top">
                                         <p class="control">
                                             <b-button type="is-success" icon-left="close"  outlined   id="btnClear4"  @click=" setFilter_ownername('') " />
                                         </p>
                                     </b-tooltip>
                                 </b-field>
                         </div>
                     </div>
                     <div class="level-right">
                         <div class="level-item">

                         </div>

                     </div>
                 </nav>
                 </div>
                 <div style="margin-top: 10px;">
                 <nav class="level is-mobile" >
                     <div class="level-left">
                         <div class="level-item">
                                 <!-- <img
                                         v-if="loadingMasterDataPathologists"
                                         :src="spiningGif"
                                 > -->
                                 <b-field label="Pathologist">
                                     <b-select   v-model="filter_patho_selectedModel" >
                                         <option  v-for="pathologist in pathologists" :key="pathologist.id" v-bind:value="pathologist.id"> {{ pathologist.name }}   {{ pathologist.surname }}</option>
                                     </b-select>
                                     <b-tooltip label="Clear Pathologist" position="is-top">
                                         <p class="control">
                                             <b-button type="is-success" icon-left="close"  outlined  id="btnClear5"  @click="setFilter_patho_selected(null)"  />
                                         </p>
                                     </b-tooltip>
                                 </b-field>
                         </div>

                         <div class="level-item">
                                 <!-- <img
                                         v-if="loadingMasterDataStatusLab"
                                         :src="spiningGif"
                                 > -->
                                 <b-field label="Status" >
                                     <b-select   v-model="filter_status_selectedModel" >
                                         <!--                                    <option value="" selected > All </option>-->
                                         <option  v-for="statusLab in getStatusLabs"    :key="statusLab.id" v-bind:value="statusLab.id"> {{ statusLab.name }}   </option>
                                     </b-select>
                                     <b-tooltip label="Clear Status" position="is-top">
                                         <p class="control">
                                             <b-button type="is-success" icon-left="close"  outlined   id="btnClear6"   @click="setFilter_status_selected('')" />
                                         </p>
                                     </b-tooltip>
                                 </b-field>
                         </div>

                         <div class="level-item">

                                 <!-- <img
                                         v-if="loadingDockind"
                                         :src="spiningGif"
                                 > -->
                                 <b-field label="Doc. Kind">
                                     <b-select   v-model="filter_docKind_selectedModel" >
                                     <!-- <b-select   v-model="filter_selected.docKind_selected" > -->
<!--                                         <option  v-for="dockind in docKind" :key="dockind.id" v-bind:value="dockind.id"> {{ dockind.name }}   </option>-->
                                         <option  v-for="dockind in docKindAll" :key="dockind.id" v-bind:value="dockind.id"> {{ dockind.name }}   </option>
                                     </b-select>
                                     <b-tooltip label="Clear Doc. Kind" position="is-top">
                                         <p class="control">
                                             <b-button type="is-success" icon-left="close"  outlined   id="btnClear7"  @click=" setFilter_docKind_selected('') " />
                                         </p>
                                     </b-tooltip>
                                 </b-field>

                         </div>





                                 <!--                             <b-field label="Refresh">-->
                                 <!--                                 <b-button type="is-success"  :disabled="isDisableFilterBtn"  outlined @click="doFilter">-->
                                 <!--                                     <b-icon-->
                                 <!--                                             icon="refresh"-->
                                 <!--                                             size="is-small">-->
                                 <!--                                     </b-icon>-->
                                 <!--                                 </b-button>-->
                                 <!--                             </b-field>-->




                                 <!--                             <b-field label="Reset">-->
                                 <!--                                 <b-button type="is-danger"  :disabled="isDisableFilterBtn"  outlined @click="setInit">-->
                                 <!--                                     <b-icon-->
                                 <!--                                             icon="close"-->
                                 <!--                                             size="is-small">-->
                                 <!--                                     </b-icon>-->
                                 <!--                                 </b-button>-->
                                 <!--                             </b-field>-->

                             <div class="level-item">

                                 <b-field label="Clear Check" v-if="checkedRows.length>0">
                                     <button class="button field is-danger" @click="checkedRows = []"
                                             :disabled="!checkedRows.length">
                                         <b-icon icon="close"></b-icon>
                                         <span>Clear checked</span>
                                     </button>
                                 </b-field>
                             </div>

                             <div class="level-item">
                                 <b-field label="Add To Favorite" v-if="checkedRows.length>0" >
                                     <button class="button field is-info" v-if="checkedRows.length>0" @click="showDlgConfirmToAddOPDToFav">
                                         <b-icon icon="book-plus"></b-icon>
                                         <span>Add To Favorite  <span  style=" color: honeydew"><strong>( {{ checkedRows.length }}  )</strong></span> </span>
                                     </button>
                                 </b-field>
                             </div>

                             <div class="level-item">
                                 <b-field label="Refresh"  >
                                     <b-button type="is-success" outlined  :disabled="isDisableFilterBtn"  @click="doFilter" >Refresh</b-button>
                                 </b-field>
                             </div>
                             <div class="level-item">
                                 <b-field label="Clear All"  >
                                     <b-button type="is-danger"  :disabled="isDisableFilterBtn"  outlined @click="setInit" >Reset</b-button>
                                 </b-field>

                              </div>

                             <div class="level-item">
                                 <b-field label="Hold Only"  v-if="CBCWorkList.length>0 && CBCWorkList[0].kind === 'CBC'  " >
                                     <b-switch  size="is-large"  type="is-warning" v-model="isCBCHoldOnly">
                                     </b-switch>
                                 </b-field>
                             </div>


                     </div>
                     <div class="level-right">
                         <div class="level-item">
                             <SearchBy v-if="isShowSearchByCompModel"  :dataToChild="resultSearchByModel"/>
                         </div>
                     </div>
                 </nav>
                 </div>







             </div>
 

                <br>



                <splitpanes class="default-theme" @resize="logResizeMain($event)"  horizontal :push-other-panes="false" style="height: 100vh">
                    <!--                          tree view and main data table -->
                    <pane   :size = "panTableMasterDataSize"  >
                        <splitpanes :push-other-panes="false" @resize="logResizeTree($event)  ">
                            <!--                            tree -->
                            <pane :size="panTreeSize" style=" overflow-x: scroll; overflow-y: scroll;" >

                                <div id="tree-view"  >
                                    <div class="panel">
                                        <div class="panel-heading">
<!--                                            <b-button size="is-small"-->
<!--                                                      type="is-danger"-->
<!--                                                      icon-left="folder-move"-->
<!--                                                      @click="resetTree"-->
<!--                                            >-->
<!--                                                Reset Tree-->
<!--                                            </b-button>-->
                                            &nbsp;&nbsp;
                                            <b-button size="is-small"
                                                      type="is-primary"
                                                      icon-left="content-save"
                                                      @click="addFolder"
                                            >
                                                Add Folder
                                            </b-button>
                                            &nbsp;&nbsp;&nbsp;
                                            <b-button size="is-small"
                                                      type="is-success"
                                                      icon-left="database-import"
                                                      @click="saveFavTreeToDB"
                                            >
                                                Apply
                                            </b-button>
                                            &nbsp;




                                            <div  class="container flex">
                                                <div class="example-tree">

                                                    <v-jstree :data="favTree"
                                                              draggable
                                                              size="large"
                                                              @item-click="itemClick">
                                                        <template scope="_">
                                                            <div style="display: inherit; width: 500px" >
<!--                                                                <button id="btn-item-tree-enter" @click="btnNodeTreeEnterPress(_.model.id,_.model.dockind,_.model.idopd)"  v-if="_.model.kind!==1"> <i class="fa fa-arrow-circle-right "></i> </button> &nbsp;&nbsp;&nbsp;-->

                                                                <i :class="_.vm.themeIconClasses" role="presentation" v-if="!_.model.loading"></i>
                                                                {{_.model.text}}
                                                                <button id="btn-item-tree-delete" @click="btnRemovePress(_.model.id)"> <i class="fa fa-trash-alt "></i> </button>
                                                                <button id="btn-item-tree-enter" @click="btnNodeTreeEnterPress(_.model.id,_.model.dockind,_.model.idopd)"  v-if="_.model.kind!==1"> <i class="fa fa-arrow-circle-right "></i> </button> &nbsp;&nbsp;&nbsp;
                                                                <button id="btn-item-tree-edit"  @click="btnEditPress(_.model.id)"  v-if="_.model.kind===1">  <i class="fa fa-edit"></i></button>

                                                            </div>

                                                        </template>
                                                    </v-jstree>



                                                </div>
                                            </div>
                                        </div>

                                    </div>
                                </div>
                            </pane>
                            <!--                            table main data-->
                            <!--                            table main data-->
                            <!--                            table main data-->
                            <!--                            table main data-->
                            <!--                            table main data-->

                            <pane :size="100 - panTreeSize"  style=" overflow-x: scroll; overflow-y: scroll;">
                                <section   >
                                    <b-field grouped group-multiline>
 


                                    </b-field>

                                    <b-tabs>

                                        <b-tab-item label="List of Lab No." >
 

                                               <MediaSketeon  v-if="loadingDataLNList"    />

                                                <b-table
                                                        v-else

                                                        paginated
                                                        :per-page="perPage"
                                                        :current-page.sync="currentPage"
      

                                                        :data="isEmpty ? [] : lnList_ModifiedForDisplay "
                                                        :bordered="isBordered"
                                                        :striped="isStriped"
                                                        :narrowed="isNarrowed"
                                                        :hoverable="isHoverable"
                                                        :loading="isLoading"
                                                        :focusable="isFocusable"
                                                        :mobile-cards="hasMobileCards"
                                                        :checked-rows.sync="checkedRows"
                                                        :selected.sync="selected"
                                                        :is-row-checkable= " (row) => row.status !== '3'"
                                                        checkable
                                                        :checkbox-position="checkboxPosition"
                                                >



                                                        <b-table-column  label="Lab No." centered v-slot="props">
                                                            <b-button :type=" props.row.status_lab_cbc ? 'is-info' :  'is-danger is-light'  "
                                                                @click="viewLab(props.row.idlab ,props.row.kind)"
                                                                :icon-left=" props.row.status_lab_cbc ? '' :  'cancel'  "
                                                                >
                                                             {{ props.row.idlab }}
                                                        
                                                             </b-button>
                                                        </b-table-column>

                                                        <template v-if="lnList_ModifiedForDisplay.length>0 && lnList_ModifiedForDisplay[0].kind =='CBC' ">


                                                            <b-table-column  label="Penquin" centered  v-slot="props"  >
                                                                <b-button icon-left="gesture-tap"  @click="showDialogOperations(props.row)"></b-button>
                                                            </b-table-column>

                                                            <b-table-column  label="Ref1" width="40" v-slot="props">
                                                                <b-button type="is-text" @click="editRef1(props.row)">{{props.row.ref1}}</b-button>
                                                            </b-table-column>


                                                            <b-table-column  label="Hold" width="40" v-slot="props">
                                                               <span class="tag is-warning is-light"   v-if="props.row.hold" >
                                                                  Hold
                                                               </span>

                                                            </b-table-column>


                                                        </template>








                                                        <b-table-column label="Kind" width="5"  centered v-slot="props">
                                                            <span class="tag is-warning"  >
                                                             {{props.row.kind}}
                                                            </span>
 

                                                           

                                                        </b-table-column>

                                                        <!-- <b-table-column label="Category" width="40"  centered v-slot="props">
                                                           
                                                           <b-taglist v-if="props.row.kind2"  >
                                                                <b-tag   class="small-text" v-for="arrKind2 in props.row.kind2" :key="arrKind2">
                                                                   {{arrKind2}}
                                                                </b-tag>
                                                            </b-taglist>

                                                         
                                                            
                                                        </b-table-column>     -->

                                                        <b-table-column   label="OPD No." width="40" numeric centered v-slot="props">
                                                            <small>{{ props.row.idopd }}</small>
                                                        </b-table-column>



                                                        <b-table-column field="opdname" label="Pet Name" centered v-slot="props">
                                                            <small>{{ props.row.opdname }}</small>
                                                        </b-table-column>

                                                        <b-table-column field="type" label="Species/Type" centered v-slot="props">
                                                            <small>{{ props.row.type }}</small>
                                                        </b-table-column>

                                                        <b-table-column field="age" label="Age" centered v-slot="props">
                                                            <small> {{ props.row.age }} </small>
                                                        </b-table-column>

                                                        <b-table-column field="owner_name" label="Owner name" centered v-slot="props">
                                                            <small>{{ props.row.owner_name }} </small>
                                                        </b-table-column>

                                                        <b-table-column label="Gender" centered v-slot="props">
                                                            <span >
                                                                <b-icon pack="fas" type="is-text"
                                                                        :icon="props.row.gender === 'M' ? 'mars' : 'venus'">
                                                                 </b-icon>

                                                            </span>
                                                        </b-table-column>

                                                        <b-table-column centered label="Request" width="40" v-slot="props">
                                                            <b-icon

                                                                    v-if="props.row.datetime_req_ts"
                                                                    icon="check-circle"
                                                                    size="is-small"
                                                                    type="is-info">
                                                            </b-icon>
    <!--                                                        <b-tag rounded   type="is-primary is-light" v-if="props.row.datetime_req_ts" > {{ props.row.datetime_req_ts }}</b-tag>-->
                                                        </b-table-column>

                                                        <b-table-column  centered  label="Accept" width="40" v-slot="props">
                                                            <b-icon

                                                                    v-if="props.row.datetime_accept_ts"
                                                                    icon="check-circle"
                                                                    size="is-small"
                                                                    type="is-info">
                                                            </b-icon>
    <!--                                                        <b-tag rounded   type="is-primary is-light" v-if="props.row.datetime_accept_ts" > {{ props.row.datetime_accept_ts }}</b-tag>-->
                                                        </b-table-column>

                                                        <b-table-column  centered  label="Cancel" width="40" v-slot="props">
                                                            <b-icon

                                                                    v-if="props.row.datetime_cancel_ts"
                                                                    icon="close-circle-outline"
                                                                    size="is-small"
                                                                    type="is-danger">
                                                            </b-icon>
    <!--                                                             <b-tag rounded   type="is-primary is-light" v-if="props.row.datetime_cancel_ts" > {{ props.row.datetime_cancel_ts }}</b-tag>-->
                                                        </b-table-column>
    <!--                                                             label="DateTime Reject"      -->
                                                        <b-table-column  centered  label="Reject" width="40" v-slot="props" >
                                                            <b-icon

                                                                    v-if="props.row.datetime_reject_ts"
                                                                    icon="close-circle-outline"
                                                                    size="is-small"
                                                                    type="is-danger">
                                                            </b-icon>
    <!--                                                            <b-tag rounded   type="is-primary is-light" v-if="props.row.datetime_reject_ts" > {{ props.row.datetime_reject_ts }}</b-tag>-->
                                                        </b-table-column>

                                                        <b-table-column centered  label="Result" width="40" v-slot="props">
                                                            <b-icon

                                                                    v-if="props.row.datetime_resulted_ts"
                                                                    icon="check-circle"
                                                                    size="is-small"
                                                                    type="is-info">
                                                            </b-icon>
    <!--                                                            <b-tag rounded   type="is-primary is-light" v-if="props.row.datetime_resulted_ts" > {{ props.row.datetime_resulted_ts }}</b-tag>-->
                                                        </b-table-column>





                                                        <b-table-column  label="Status" width="40" v-slot="props">
                                                              <span class="tag"  :class="labStatusColor(props.row.status )" >
                                                                   {{props.row.status}}
                                                                    
                                                               </span>
                                                        </b-table-column>



                                                    <template v-if="lnList_ModifiedForDisplay.length>0 && lnList_ModifiedForDisplay[0].kind !=='CBC' ">

                                                        <b-table-column  label="Pathologist" v-slot="props">
                                                            <small>{{ props.row.pathologist }} </small>
                                                        </b-table-column>

                                                    </template>


                                                    <template slot="empty">
                                                        <section class="section">
                                                            <div class="content has-text-grey has-text-centered">
                                                                <p>
                                                                    <b-icon
                                                                            icon="emoticon-sad"
                                                                            size="is-large">
                                                                    </b-icon>
                                                                </p>
                                                                <p>Nothing here.</p>
                                                            </div>
                                                        </section>
                                                    </template>
                                                    <template slot="footer"  >
                                                        <div class="box">
                                                            <div  class="level-left" >    <b>Total checked</b>: {{ checkedRows.length }}</div>
                                                            <!-- <div  class="level-right" >    <b-button type="is-primary" outlined v-show="lnList.length>0"  :disabled="isDisableMoreBtn"  :loading="isMoreBtnLoading" @click="doFilterMore" >More..</b-button></div> -->
                                                        </div>
                                                    </template>



    <!--                                                <template slot="bottom-left">-->
    <!--                                                    <b>Total checked</b>: {{ checkedRows.length }}-->


    <!--                                                </template>-->

    <!--                                                <div class="box ">-->
    <!--&lt;!&ndash;                                                    <div  class="level-left" > <div class="level-item"> <b>Total checked</b>: {{ checkedRows.length }}</div></div>&ndash;&gt;-->
    <!--                                                    <div  class="level-right" > <div class="level-item"> <b-button type="is-primary" outlined v-show="lnList.length>0" >More..</b-button></div></div>-->
    <!--                                                </div>-->

                                                </b-table>



                                        </b-tab-item>


<!--                                        <b-tab-item label="selected">-->
<!--                                            {{selected }}-->
<!--                                        </b-tab-item>-->



                                    </b-tabs>
                                </section>
                            </pane>
                        </splitpanes>
                    </pane>
                    <!--   table child data-->
                    <!--   table child data-->
                    <!--   table child data-->
                    <!--   table child data-->
                    <!--   table child data-->
                    <!--   table child data-->
                    <!--   table child data-->
                    <pane :size = "100 -panTableMasterDataSize"    style=" overflow-x: scroll; overflow-y: scroll;">
                        <div id="main-view"  >
                         
<!--                            <b-tabs >-->
<!--                                <b-tab-item label="Automate">-->


<!--                                    CBC Only-->
<!--                                </b-tab-item>-->

<!--                                <b-tab-item label="Non Automate">-->
<!--                                    Cyto.-->
<!--                                    Biopsy.-->
<!--                                    PCR.-->
<!--                                    etc.-->
<!--                                </b-tab-item>-->
<!--                            </b-tabs>-->




                          <section style="margin-bottom: 10px;margin-top: 10px;">
                    
                            <nav class="level is-mobile" v-if="selected">
                                <div class="level-left">
                                    <div class="level-item">
                                        <strong style="color: mediumvioletred"> OPD No :  </strong>    &nbsp;&nbsp; <small  style="color: lightslategrey">{{ selected.idopd  }}</small>
                                    </div>
                                    <div class="level-item">
                                         <strong style="color: mediumvioletred"> Pet Name :   </strong>    &nbsp;&nbsp; <small  style="color: lightslategrey">{{ selected.opdname  }}</small>
                                    </div>
                                    <div class="level-item">
                                        <strong style="color: mediumvioletred"> Owner Name : </strong>    &nbsp;&nbsp; <small  style="color: lightslategrey"> {{ selected.owner_name  }}</small>  &nbsp;&nbsp;
                                    </div>
                                    <div class="level-item">
                                        <strong style="color: mediumvioletred"> Age : </strong>   &nbsp;&nbsp;  <small  style="color: lightslategrey"> {{ selected.age  }} </small> &nbsp;
                                    </div>
                                    <div class="level-item">
                                        <strong style="color: mediumvioletred"> Type : </strong>   &nbsp;&nbsp; <small  style="color: lightslategrey"> {{ selected.type  }} </small>
                                    </div>
                                    <div class="level-item">
                                        <strong style="color: mediumvioletred"> Gender : </strong>   &nbsp;&nbsp;  <b-icon pack="fas" type="is-text" :icon="selected.gender === 'M' ? 'mars' : 'venus'"> </b-icon> &nbsp;
                                    </div>
                                    <div class="level-item">
                                        <span> Total Lab <b-tag  type="is-info" rounded v-if="listoflabopdtarget_v2.length>0"> {{ listoflabopdtarget_v2.length }}  </b-tag> </span>
                                    </div>
                                </div>
                                <div class="level-right">
                                    <div class="level-item">
<!--                                        <b-tag type="is-dark">Found records</b-tag>-->
<!--                                        <b-tag type="is-dark">{{  listOfLabOPDTarget_ModifiedForDisplay.length }}</b-tag>-->

                                    </div>

                                </div>
                            </nav>
                          </section>
                          <section style="margin-bottom: 10px;margin-top: 10px;">
                          
                            <img
                                    v-if="loadingLnListSpecOPDNo"
                                    :src="spiningGif"
                            >
 
                              
                             <ListOfLabEachOPD v-else
                                 @viewLabEmitBy_ListOfLabEachOPD="viewLabEmitBy_ListOfLabEachOPD"/>

<!--                            <b-table v-else-->
<!--                                     :data="isEmpty ? [] : listOfLabOPDTarget_ModifiedForDisplay"-->
<!--                                     :bordered="isBordered"-->
<!--                                     :striped="isStriped"-->
<!--                                     :narrowed="isNarrowed"-->
<!--                                     :hoverable="isHoverable"-->
<!--                                     :loading="isLoading"-->
<!--                                     :focusable="isFocusable"-->
<!--                                     :mobile-cards="hasMobileCards"-->
<!--                                     paginated-->
<!--                                     pagination-size="is-medium"-->
<!--                                     pagination-position="bottom"-->
<!--                                     :current-page.sync="currentPage"-->
<!--                                     :per-page="perPage">-->


<!--                                    <b-table-column  label="Lab No."  centered  v-slot="props">-->
<!--                                        <b-button type="is-info" @click="viewLab(props.row.idlab ,props.row.kind)">{{ props.row.idlab }} </b-button>-->
<!--                                    </b-table-column>-->


<!--                                    <b-table-column   label="Kind"    v-slot="props" >-->
<!--                                            <span class="tag is-warning"  >-->
<!--                                                         {{props.row.kind}}-->
<!--                                            </span>-->
<!--                                    </b-table-column>-->

<!--                                    <b-table-column  label="DateTime Req."    v-slot="props" >-->

<!--                                             <span class="tag"  v-if="props.row.datereq" style="color: teal" >-->
<!--                                                      {{ props.row.datereq }} - {{ props.row.timereq }}-->
<!--                                             </span>-->
<!--&lt;!&ndash;                                             <span class="tag"  v-if="props.row.datereq.length>0" style="color: teal" >&ndash;&gt;-->
<!--&lt;!&ndash;                                                      {{ props.row.datereq }} - {{ props.row.timereq }}&ndash;&gt;-->
<!--&lt;!&ndash;                                             </span>&ndash;&gt;-->
<!--                                        <p v-else></p>-->

<!--                                    </b-table-column>-->
<!--                                    <b-table-column  label="Req. By"  v-slot="props">-->
<!--                                        {{ props.row.reqby }}-->
<!--                                    </b-table-column>-->

<!--                                    <b-table-column  field="status" label="Status" centered  v-slot="props">-->
<!--                                                       <span class="tag" :class="labStatusColor(props.row.status )"  >-->
<!--                                                         {{props.row.status}}-->
<!--                                                       </span>-->
<!--                                    </b-table-column>-->



<!--                                <template slot="empty">-->
<!--                                    <section class="section">-->
<!--                                        <div class="content has-text-grey has-text-centered">-->
<!--                                            <p>-->
<!--                                                <b-icon-->
<!--                                                        icon="emoticon-sad"-->
<!--                                                        size="is-large">-->
<!--                                                </b-icon>-->
<!--                                            </p>-->
<!--                                            <p >Nothing here.</p>-->
<!--                                        </div>-->
<!--                                    </section>-->
<!--                                </template>-->
<!--                            </b-table>-->




                          </section>



                        </div>
                    </pane>

                </splitpanes>
 
                <DlgConfirmToAddOPDToFav v-if="isModalDlgConfirmToAddOPDToFav" @close="closeDlgConfirmToAddOPDToFav"  @closeWithChange="closeDlgConfirmToAddOPDToFav_WithChange" :dataToChild="checkedRows"></DlgConfirmToAddOPDToFav>
                <DlgEditFolderName v-if="isModalEditFolderName" @close="closeDlgEditFolderName"  @closeWithChange="closeDlgEditFolderNameWithChange" :dataToChild=dataToDelOrRename></DlgEditFolderName>
            </b-tab-item>

<!--            Tab OPD Space  -->
            <b-tab-item >
                <template slot="header">
                    <b-icon icon="paw"></b-icon>
<!--                    <span> OPD Space Zone  </span>-->
                    <span> OPD Space Zone <b-tag  type="is-info" rounded v-if="OPDSelected"> {{OPDSelected.opdname}} / {{ OPDSelected.idopd }}  </b-tag> </span>
                </template>

                <OPDSpace ref="OPDSpace" />
            </b-tab-item>

<!--            Tab Order List -->
            <b-tab-item >
                <template slot="header">
                    <b-icon icon="format-list-checkbox"></b-icon>
                    <!--                    <span> OPD Space Zone  </span>-->
                    <span> Order List <b-tag  type="is-info" rounded  >  {{ ordersList.length }}   </b-tag> </span>
                </template>

                <OrdersList ref="OrdersList" />
            </b-tab-item>


            <b-tab-item   >
                <template slot="header">
                    <b-icon icon="briefcase-outline"></b-icon>
                    <!--                    <span> OPD Space Zone  </span>-->
                    <span> My Jobs Tray Assigned <b-tag  type="is-info" rounded  >  {{ myJobsTrayAssigned.length }}   </b-tag> </span>
<!--                    <span>  My Jobs Tray <b-tag  type="is-warning" rounded  >  {{getNameAndSurname}}  <b-tag  type="is-info" rounded  >  {{ myJobsTray.length }}   </b-tag> </b-tag> </span>-->
                </template>

<!--                <MyJobsTray ref="MyJobsTray" />-->
            <MyJobTrayAssigned :status=2   />
            </b-tab-item>

            <b-tab-item  >
                <template slot="header">
                    <b-icon icon="briefcase-outline"></b-icon>
                    <!--                    <span> OPD Space Zone  </span>-->
                    <span> My Jobs Tray Prepared <b-tag  type="is-info" rounded  >  {{ myJobsTrayPrepared.length }}   </b-tag> </span>
                    <!--                    <span>  My Jobs Tray <b-tag  type="is-warning" rounded  >  {{getNameAndSurname}}  <b-tag  type="is-info" rounded  >  {{ myJobsTray.length }}   </b-tag> </b-tag> </span>-->
                </template>

                <MyJobTrayPrepared :status=3 />
            </b-tab-item>

            <b-tab-item   >
                <template slot="header">
                    <b-icon icon="briefcase-outline"></b-icon>
                    <!--                    <span> OPD Space Zone  </span>-->
                    <span> My Jobs Tray Draft <b-tag  type="is-info" rounded  >  {{ myJobsTrayDraft.length }}   </b-tag> </span>
                    <!--                    <span>  My Jobs Tray <b-tag  type="is-warning" rounded  >  {{getNameAndSurname}}  <b-tag  type="is-info" rounded  >  {{ myJobsTray.length }}   </b-tag> </b-tag> </span>-->
                </template>

                <MyJobTrayDraft :status=4 />
            </b-tab-item>

<!--            <b-tab-item :disabled = "!userRoleFind(3) || !userRoleFind(4) || userRoleFind(6)  " >-->
            <b-tab-item  >
                <template slot="header">
                    <b-icon icon="briefcase-outline"></b-icon>
                    <!--                    <span> OPD Space Zone  </span>-->
                    <span> My Jobs Tray Incomplete <b-tag  type="is-info" rounded  >  {{ myJobsTrayIncomplete.length }}   </b-tag> </span>
                    <!--                    <span>  My Jobs Tray <b-tag  type="is-warning" rounded  >  {{getNameAndSurname}}  <b-tag  type="is-info" rounded  >  {{ myJobsTray.length }}   </b-tag> </b-tag> </span>-->
                </template>

                <MyJobTrayInComplete :status=5 @MyJobTrayLabStatus5WantToSwapTabToView="MyJobTrayLabStatus5WantToSwapTabToView" />
            </b-tab-item>




       </b-tabs>



        <DialogOperations
                v-if="isDialogOperations"
                :isDialogOperations="isDialogOperations"
                :dataProps1="propsToDialogOperations"
                @close="closeDialogOperations"
                @closeWithChange = "closeDialogOperationsWithChange"
                @changeHoldStatus = "changeHoldStatus" >

        </DialogOperations>



    </div>


</template>

<script>
    /* eslint-disable no-console */
    import {  formatNumber , getBaseURLforBackEnd  , getConfigAxios ,spiningGif , genUUID , firstSelectParam  ,checkAccessTokenWithFpValid, getCurrentDate } from '@/utils.js'
    import { Splitpanes, Pane } from 'splitpanes'
    import 'splitpanes/dist/splitpanes.css'
    import VJstree from 'vue-jstree'
    import {mapState, mapActions , mapGetters, mapMutations } from 'vuex'
    import axios from "axios";
    import DlgConfirmToAddOPDToFav from '@/components/FavTree/DlgConfirmToAddOPDToFav'
    import DlgEditFolderName from "./FavTree/DlgEditFolderName";
    import SearchBy from "./SearchParam/SearchBy";
    import moment from 'moment'
    import OPDSpace from "./OPDSpace";
    import OrdersList from "./OrdersList/OrdersList";
    import labStatusColor from "../mixins/methods/labStatusColor";
    // import MyJobsTray from "./MyJobsTray/MyJobsTray";
    // import { EventBus } from '@/event-bus.js';
    import userRoleFind from "../mixins/methods/userRoleFind";
    import MyJobTrayAssigned from "./MyJobsTray/MyJobTrayAssigned";
    import MyJobTrayPrepared from "./MyJobsTray/MyJobTrayPrepared";
    import MyJobTrayDraft from "./MyJobsTray/MyJobTrayDraft";
    import MyJobTrayInComplete from "./MyJobsTray/MyJobTrayInComplete";
    import findDiffDate from "../mixins/methods/findDiffDate";
    import dateFormatterForDatePicker from "../mixins/methods/dateFormatterForDatePicker";
    import getISO8601ToYearMonthDate from "../mixins/methods/getISO8601ToYearMonthDate";
    import MediaSketeon from "./UtilsComponents/MediaSketeon";
    import ListOfLabEachOPD from "./ListOfLabEachOPD";


    import {DateTime} from "luxon";
    import DialogOperations from "./PenguinPoodle/DialogOperations";


    export default {
        name: 'app',
        components: {
            Splitpanes,
            Pane,
            VJstree ,
            DlgConfirmToAddOPDToFav,
            DlgEditFolderName,
            SearchBy,
            OPDSpace,
            OrdersList,
            // MyJobsTray
            MyJobTrayAssigned,
            MyJobTrayPrepared,
            MyJobTrayDraft,
            MyJobTrayInComplete,
            MediaSketeon,
            ListOfLabEachOPD,
            DialogOperations,

        },
        computed:{
            ...mapState({
               // opdPathoJobList: state => state.patho_opd_job_worklist.opdPathoJobList ,
                pathologists : state => state.master_data.pathologists ,
                statusLabs : state => state.master_data.statusLabs ,
                user_id : state => state.master_data.user_id ,
                clientIP : state => state.master_data.clientIP ,
                OPDSelected : state => state.opd_target.opd_selected,
                // listOfLabOPDTarget: state => state.listoflab_opdtarget.listoflabopdtarget,
                listoflabopdtarget_v2 : state => state.listoflab_opdtarget.listoflabopdtarget_v2,
                IDLABSelected : state => state.lab_target.lab_selected,
                fingerPrint : state => state.master_data.fingerPrint,
                ordersList : state => state.orders.ordersList,
                counterTest: state => state.master_data.counterTest ,
                myJobsTrayAssigned :  state => state.myjobstray.myJobsTrayAssigned ,
                myJobsTrayPrepared :  state => state.myjobstray.myJobsTrayPrepared ,
                myJobsTrayDraft :  state => state.myjobstray.myJobsTrayDraft ,
                myJobsTrayIncomplete :  state => state.myjobstray.myJobsTrayIncomplete ,
                user_role : state => state.master_data.user_role,

                docKind : state => state.master_data.docKind,
                docKindAll : state => state.master_data.docKindAll,

                access_token: state => state.master_data.access_token,

                // worklist
                CBCWorkList: state => state.worklist.CBCWorkList,
                filter_dateKindsSelected : state => state.worklist.filter_dateKindsSelected,
                dateKinds : state => state.worklist.dateKinds,
                isShowSearchByComp: state => state.worklist.isShowSearchByComp,
                resultSearchBy: state => state.worklist.resultSearchBy,
                filter_date_selected_start : state => state.worklist.filter_date_selected_start,
                filter_date_selected_end : state => state.worklist.filter_date_selected_end,
                filter_opdno :  state => state.worklist.filter_opdno,
                filter_opdname :  state => state.worklist.filter_opdname,
                filter_ownername:  state => state.worklist.filter_ownername,
                filter_patho_selected:  state => state.worklist.filter_patho_selected,
                filter_status_selected:  state => state.worklist.filter_status_selected,
                filter_docKind_selected:  state => state.worklist.filter_docKind_selected,



            
              

            }) ,
            ...mapGetters('listoflab_opdtarget',{
                listOfLabOPDTarget_ModifiedForDisplay : 'listOfLabOPDTarget_ModifiedForDisplay',
            }),

            filter_dateKindsSelectedModel:{
                    get: function () {
                         return  this.filter_dateKindsSelected 
                    },
                    set: function (newValue) {
                        this.setFilter_dateKindsSelected(newValue)
                    }
            },


            filter_docKind_selectedModel:{
                    get: function () {
                         return  this.filter_docKind_selected 
                    },
                    set: function (newValue) {
                        this.setFilter_docKind_selected(newValue)
                    }
            }, 
            filter_status_selectedModel:{
                    get: function () {
                         return  this.filter_status_selected 
                    },
                    set: function (newValue) {
                        this.setFilter_status_selected(newValue)
                    }
            },
            filter_patho_selectedModel:{
                    get: function () {
                         return  this.filter_patho_selected 
                    },
                    set: function (newValue) {
                        this.setFilter_patho_selected(newValue)
                    }
            },
            resultSearchByModel:{
                    get: function () {
                         return  this.resultSearchBy 
                    },
                    set: function (newValue) {
                        this.setResultSearchBy(newValue)
                    }
            },
            isShowSearchByCompModel :{
                    get: function () {
                         return  this.isShowSearchByComp 
                    },
                    set: function (newValue) {
                        this.setIsShowSearchByComp(newValue)
                    }
            },


            filter_ownernameModel : {
                    get: function () {
                         return  this.filter_ownername 
                    },
                    set: function (newValue) {
                        this.setFilter_ownername(newValue)
                    }
            },


            filter_opdnameModel : {
                 get: function () {
                         return  this.filter_opdname 
                    },
                    set: function (newValue) {
                        this.setFilter_opdname(newValue)
                    }
            },

            filter_opdnoModel : {
                 get: function () {
                         return  this.filter_opdno 
                    },
                    set: function (newValue) {
                        this.setFilter_opdno(newValue)
                    }
            },


            filter_date_selected_startModel : {
                 get: function () {
                         return  this.filter_date_selected_start 
                    },
                    set: function (newValue) {
                        this.setFilter_date_selected_start(newValue)
                    }
            },

            filter_date_selected_endModel : {
                 get: function () {
                         return  this.filter_date_selected_end 
                    },
                    set: function (newValue) {
                        this.setFilter_date_selected_end(newValue)
                    }
            },




            getStatusLabs: function(){
                return this.statusLabs.filter(dat=>{
                    return dat.dispy_front
                })
            },

            getNameAndSurname(){
                return localStorage.getItem('user_name_surname')
            },



            lnList_ModifiedForDisplay : function(){


                // {  "idopd": data_result[0] ,
                //     "idlab": data_result[1],
                //     "opdname": data_result[2],
                //     "owner_name": data_result[4],
                //     "status": data_result[5].strip(),
                //     "gender": data_result[6],
                //     "age_day": data_result[7],
                //     'age': cal_age_from_totalday(data_result[7]),
                //     "kind": data_result[8],
                //     "automate": data_result[9] ,

                //     "datetime_req_ts":  None if data_result[10] is None else data_result[10].isoformat()  ,
                //     "user_req": data_result[11],

                //     "datetime_accept_ts":   None if data_result[12] is None else data_result[12].isoformat()  ,
                //     "user_accept": data_result[13],

                //     "datetime_cancel_ts": None if data_result[14] is None else data_result[14].isoformat()  ,
                //     "user_cancel": data_result[15],

                //     "datetime_reject_ts": None if data_result[16] is None else data_result[16].isoformat()  ,
                //     "user_reject": data_result[17],

                //     "datetime_resulted_ts": None if data_result[18] is None else data_result[18].isoformat() ,
                //     "user_resulted": data_result[19],
                //     }

// this.lnList
                    return  this.CBCWorkList
                        .filter(dat =>
                            this.isCBCHoldOnly ? dat.hold == 1 : dat
                         )
                        .map (dat => {

                        var  tmp_datetime_req_ts =   null
                        var  tmp_datetime_accept_ts = null
                        var  tmp_datetime_cancel_ts = null
                        var  tmp_datetime_reject_ts = null
                        var  tmp_datetime_resulted_ts = null


                        tmp_datetime_req_ts  =       dat.datetime_req_ts !== null
                                                            ?
                                                            ` ${ this.getISO8601ToYearMonthDate(dat.datetime_req_ts).date}  ${this.getISO8601ToYearMonthDate(dat.datetime_req_ts).month} ${this.getISO8601ToYearMonthDate(dat.datetime_req_ts).year }   -    ${this.getISO8601ToYearMonthDate(dat.datetime_req_ts).hour} : ${this.getISO8601ToYearMonthDate(dat.datetime_req_ts).minute }  : ${this.getISO8601ToYearMonthDate(dat.datetime_req_ts).second } `
                                                            :
                                                            null

                        tmp_datetime_accept_ts =         dat.datetime_accept_ts !== null
                                                            ?
                                                            ` ${ this.getISO8601ToYearMonthDate(dat.datetime_accept_ts).date}  ${this.getISO8601ToYearMonthDate(dat.datetime_accept_ts).month} ${this.getISO8601ToYearMonthDate(dat.datetime_accept_ts).year }   -    ${this.getISO8601ToYearMonthDate(dat.datetime_accept_ts).hour} : ${this.getISO8601ToYearMonthDate(dat.datetime_accept_ts).minute }  : ${this.getISO8601ToYearMonthDate(dat.datetime_accept_ts).second } `
                                                            :
                                                            null

                        tmp_datetime_cancel_ts =        dat.datetime_cancel_ts !== null
                                                            ?
                                                            ` ${ this.getISO8601ToYearMonthDate(dat.datetime_cancel_ts).date}  ${this.getISO8601ToYearMonthDate(dat.datetime_cancel_ts).month} ${this.getISO8601ToYearMonthDate(dat.datetime_cancel_ts).year }   -    ${this.getISO8601ToYearMonthDate(dat.datetime_cancel_ts).hour} : ${this.getISO8601ToYearMonthDate(dat.datetime_cancel_ts).minute }  : ${this.getISO8601ToYearMonthDate(dat.datetime_cancel_ts).second } `
                                                            :
                                                            null

                        tmp_datetime_reject_ts =       dat.datetime_reject_ts !== null
                                                            ?
                                                            ` ${ this.getISO8601ToYearMonthDate(dat.datetime_reject_ts).date}  ${this.getISO8601ToYearMonthDate(dat.datetime_reject_ts).month} ${this.getISO8601ToYearMonthDate(dat.datetime_reject_ts).year }   -    ${this.getISO8601ToYearMonthDate(dat.datetime_reject_ts).hour} : ${this.getISO8601ToYearMonthDate(dat.datetime_reject_ts).minute }  : ${this.getISO8601ToYearMonthDate(dat.datetime_reject_ts).second } `
                                                            :
                                                            null


                        tmp_datetime_resulted_ts =       dat.datetime_resulted_ts !== null
                                                               ?
                                                              ` ${ this.getISO8601ToYearMonthDate(dat.datetime_resulted_ts).date}  ${this.getISO8601ToYearMonthDate(dat.datetime_resulted_ts).month} ${this.getISO8601ToYearMonthDate(dat.datetime_resulted_ts).year }   -    ${this.getISO8601ToYearMonthDate(dat.datetime_resulted_ts).hour} : ${this.getISO8601ToYearMonthDate(dat.datetime_resulted_ts).minute }  : ${this.getISO8601ToYearMonthDate(dat.datetime_resulted_ts).second } `
                                                              :
                                                               null


                         

                        return {

                            "idopd": dat.idopd,
                            "idlab": dat.idlab,
                            "opdname": dat.opdname,
                            "type": dat.type,
                            "owner_name": dat.owner_name,
                            "status": dat.status,
                            "gender": dat.gender,
                            "age": dat.age,
                            "kind": dat.kind,
                            "automate": dat.automate,
                            "pathologist": dat.pathologist,
                            "datetime_req_ts":tmp_datetime_req_ts,
                            "user_req":dat.user_req,
                            "datetime_resulted_ts" : tmp_datetime_resulted_ts,
                            "user_resulted" : dat.user_resulted,
                            "datetime_accept_ts" : tmp_datetime_accept_ts ,
                            "user_accept" : dat.user_accept,
                            "datetime_cancel_ts" : tmp_datetime_cancel_ts ,
                            "user_cancel": dat.user_cancel,
                            "datetime_reject_ts" : tmp_datetime_reject_ts,
                            "user_reject": dat.user_reject,
                            "ref_no": dat.ref_no ,
                            "ref1": dat.ref1 ,
                            "hold" : dat.hold,
                            "user_req_id": dat.user_req_id,
                            "patho_job": dat.patho_job,
                            "status_lab_cbc": dat.status_lab_cbc
                          //  "kind2": dat.kind2
                        }
                    })
            }

            // listOfLabOPDTargetModifiedForDisplay:function () {
            //
            //     return     this.listOfLabOPDTarget.map (dat => {
            //
            //         return {
            //             "idopd": dat.idopd,
            //             "idlab": dat.idlab,
            //             "opdname": dat.opdname,
            //             "type": dat.type,
            //             "owner_name": dat.owner_name,
            //             "status": dat.status,
            //             "gender": dat.gender,
            //             "age": dat.age,
            //             "kind": dat.kind,
            //             "automate": dat.automate,
            //             "datereq" :  customFormatDate(dat.datereq) ,
            //             "timereq" :  customFormatTime(dat.timereq) ,
            //             "reqby": dat.reqby,
            //             "dateaccept":   customFormatDate(dat.dateaccept)  ,
            //             "timeaccept":   customFormatTime(dat.timeaccept) ,
            //             "acceptby": dat.acceptby,
            //             "datecancle":   customFormatDate(dat.datecancle),
            //             "timecancle":   customFormatTime(dat.timecancle),
            //             "cancleby": dat.cancleby,
            //             "datereject":   customFormatDate(dat.datereject) ,
            //             "timereject":   customFormatTime(dat.timereject),
            //             "rejectby": dat.rejectby,
            //             "dateresult":   customFormatDate(dat.dateresult) ,
            //             "timeresult":   customFormatTime(dat.timeresult),
            //             "resultby": dat.resultby
            //         }
            //     })
            // }
        },
        beforeDestroy() {
            // console.log('destroy')
            // EventBus.$off('showLabFromOtherComponent')
        },
        created() {

            // console.log("create")
            
            

            //*******************************
            // this.isFullScreenLoading = true
            //*******************************
            // this.takeEmptyListOfLab_OPDTarget()
            // this.takeEmptyListOfLab_OPDTarget_v2()
            this.spiningGif = spiningGif()
            // this.loadingDataPathoJobList = true
            // this.loadingMasterDataPathologists = true
            // this.loadingMasterDataStatusLab = true
            // this.loadingDockind = true
            this.loadingFavTree = true

 
            // this.loadCurrentDate(2)
            // this.fetchPathologists()
            //     .then(() => this.loadingMasterDataPathologists = false)
            // this.fetchStatusLabs()
            //     .then(() => this.loadingMasterDataStatusLab = false)
            // this.fetchDocKind()
            //     .then(() => this.loadingDockind = false)



            this.loadFavTree()
            // this.setupIDOPDTarget(null)
            // this.setupIDLABTarget( {
            //     "idlab" : null,
            //     "kind" : null
            // })

            // var payloadDatTo = {
            //     "user_id": this.user_id,
            //     "status_id":  2
            // }
            // this.fetchMyJobsTray(payloadDatTo)
            // payloadDatTo.status_id = 3
            // this.fetchMyJobsTray(payloadDatTo)
            // payloadDatTo.status_id = 4
            // this.fetchMyJobsTray(payloadDatTo)


            //*******************************
            // this.isFullScreenLoading = false
            // console.log("Created "+ this.counterTest)
            if(this.counterTest === 1){
                // console.log(this.OPDSelected)
                this.btnNodeTreeEnterPress(this.IDLABSelected.idlab,this.IDLABSelected.kind,this.OPDSelected.idopd)
            }
        },
        mounted() {
            // const vm = this
            // EventBus.$once('showLabFromOtherComponent', (dat) => {
            //     console.log("Event Bus On")
            //     vm.$router.push('/worklist')
                // console.log(dat)
                // vm.viewLab(vm.IDLABSelected.idlab,vm.IDLABSelected.kind)
                // vm.$refs.OPDSpace.forceDetailEachLab()
                // console.log(JSON.stringify(this.OPDSelected))
                // console.log(JSON.stringify(this.IDLABSelected))
                //  this.viewLab(this.IDLABSelected.idlab,this.IDLABSelected.kind)
                // this.btnNodeTreeEnterPress(this.IDLABSelected.idlab,this.IDLABSelected.kind,dat.idopd)

            // })

            // this.$refs.changeToTab.$el.click()
            this.panTreeSize = localStorage.getItem('panTreeSize')
            this.panTableMasterDataSize =  localStorage.getItem('panTableMasterDataSize')
             
            // if(this.docKindAll.length>0){
            //     this.docKind_selected = this.docKindAll[0].id
            //     console.log('docKind_selected '+this.docKindAll[0].id)
            // }
            // this.setInit()
            this.docKindAll.length>0 ?     this.setFilter_docKind_selected( this.docKindAll[0].id)   :   this.setFilter_docKind_selected(null) 



            // console.log('mount worklist')




        },
        data () {
          return {
                count : 0,
                tabMain : 0,
                // resultSearchBy :{"date_selected" : "" , "opd_no": "", "opd_name": "" , "owner_name": "" , "number_of_rec_found": ""},
                // isShowSearchByComp : false,
                isDisableFilterBtn : false,


                // date_selectedStart : null,
                // date_selectedDue : null,


                filter_selected : {
                    date_selected : [],
                    patho_selected : null,
                    status_selected : null,
                    docKind_selected : null,
                    ownername: "",
                    opdno: "",
                    opdname:"",
                    first : 10,
                    skip : 0
                } ,
                // lnList:  [] ,  replace by CBCWorkList ( in store )
                selected : null,
                isEmpty: false,
                isBordered: true,
                isStriped: true,
                isNarrowed: false,
                isHoverable: true,
                isFocusable: true,
                isLoading: false,
                isFullScreenLoading : false,
                isModalDlgConfirmToAddOPDToFav : false,
                isModalEditFolderName: false,
                hasMobileCards: true ,
                checkboxPosition: 'left',
                checkedRows: [],
                isDisableMoreBtn : false ,
                isMoreBtnLoading : false,

                isCBCHoldOnly :  false,
                // currentPage : 1 ,
                // perPage: 5 ,


              // "id": tmpID,
              // "text": tmpName ,
              // "opened" : true ,
              // "children": [],
              // "selected": true,
              // "kind" : 1 ,// folder,
              // "dropDisabled": false,
              //

                favTree: []
                    // [ {
                    // "id": "Gys2zTAUbV",
                    // "text": "New Folder",
                    // "opened": true,
                    // "children": [
                    //                 {
                    //                     "id": "55027921",
                    //                     "text": "55027921 / กล้วย / สุปราณี วงศาก้อ / Male ",
                    //                     "icon": "fa fa-paw",
                    //                     "dropDisabled": true,
                    //                     "kind": 2,
                    //                     "selected": false
                    //                 },
                    //                 {
                    //                     "id": "RAlYk7YItS",
                    //                     "text": "werwerwer",
                    //                     "opened": true,
                    //                     "children": [
                    //                         {
                    //                             "id": "62005172",
                    //                             "text": "62005172 / เวนิส / สมพิศ เอียดราช / Female ",
                    //                             "icon": "fa fa-paw",
                    //                             "dropDisabled": true,
                    //                             "kind": 2,
                    //                             "selected": false
                    //                         }
                    //                     ],
                    //                     "selected": false,
                    //                     "kind": 1
                    //                 },
                    //                 {
                    //                     "id": "IJR7kG2Viv",
                    //                     "text": "55555",
                    //                     "opened": true,
                    //                     "children": [
                    //                                     {
                    //                                         "id": "62005171",
                    //                                         "text": "62005171 / ชายเดียว / บุษบา เตโช / Male ",
                    //                                         "icon": "fa fa-paw",
                    //                                         "dropDisabled": true,
                    //                                         "kind": 2,
                    //                                         "selected": true
                    //                                     }
                    //                                  ],
                    //                                 "selected": false,
                    //                                 "kind": 1
                    //                 }
                    //         ],
                    // "selected": false,
                    // "kind": 1 }
                    // ]
                 ,
                panTreeSize : 35,
                panTableMasterDataSize : 135,

                loadingDataLNList: false,
                // loadingMasterDataPathologists : false ,
                // loadingMasterDataStatusLab : false ,
                // loadingDockind : false ,
                loadingFavTree : false,
                loadingLnListSpecOPDNo : false,
                spiningGif : '',
                tmpFolderName : ''  ,
                dataToDelOrRename : { id : "" , name: "" ,dataUnderFolder :null },
                skipParamForMainTbl : 0,



                // dateKinds : [{"id":1 ,name:"Date Request"},{"id":2 ,name:"Date Result"}],
                // dateKindsSelected : 1,
                tmp : '',


              pauseItemTreeClick : false ,
              isDialogOperations : false ,
              propsToDialogOperations : {},

              perPage : 10,
              currentPage : 1,

          }
        },
        methods :{
            ...mapMutations({
              setCBCWorkList: 'worklist/setCBCWorkList',  
              setIsShowSearchByComp: 'worklist/setIsShowSearchByComp',  
              setResultSearchBy : 'worklist/setResultSearchBy', 
              setFilter_date_selected_start :  'worklist/setFilter_date_selected_start',  
              setFilter_date_selected_end :  'worklist/setFilter_date_selected_end', 
              setFilter_opdno:  'worklist/setFilter_opdno', 
              setFilter_opdname:  'worklist/setFilter_opdname', 
              setFilter_ownername:  'worklist/setFilter_ownername', 
              setFilter_patho_selected:  'worklist/setFilter_patho_selected', 
              setFilter_status_selected:  'worklist/setFilter_status_selected', 
              setFilter_docKind_selected:  'worklist/setFilter_docKind_selected',
              setFilter_dateKindsSelected:  'worklist/setFilter_dateKindsSelected',

              
            }),
            ...mapActions({
                // fetchOPDPathoJobList: 'patho_opd_job_worklist/fetchOPDPathoJobList',


                // fetchPathologists : 'master_data/fetchPathologists' ,
                // fetchStatusLabs : 'master_data/fetchStatusLabs' ,
                setupIDOPDTarget : 'opd_target/setupIDOPDTarget',


                // fetchListOfLab_OPDTarget :'listoflab_opdtarget/fetchListOfLab_OPDTarget',
                fetchListOfLab_OPDTargetV2 :'listoflab_opdtarget/fetchListOfLab_OPDTargetV2',
                produceDatGrpUniqs:  'listoflab_opdtarget/produceDatGrpUniqs',
                produceDatWantToSee: 'listoflab_opdtarget/produceDatWantToSee',
                // takeEmptyListOfLab_OPDTarget : 'listoflab_opdtarget/takeEmptyListOfLab_OPDTarget',
                takeEmptyListOfLab_OPDTarget_v2: 'listoflab_opdtarget/takeEmptyListOfLab_OPDTarget_v2',
                setupIDLABTarget : 'lab_target/setupIDLABTarget',
                produceSetCounterTest: 'master_data/produceSetCounterTest',
                fetchMyJobsTray: 'myjobstray/fetchMyJobsTray',
                // fetchDocKind : 'master_data/fetchDocKind' ,
                clearListOHistoryOrders : 'listof_historyorders/clearListOHistoryOrders',
                fetchCountIMR :  'imr/fetchCountIMR',
            }),
        editRef1Real(payload,value){
             // console.log(payload.ref1 , value)


             // change back-end
            this.isFullScreenSearching = true
            const datTo = {
                "idlab": payload.idlab,
                "value": value
            }
            axios.defaults.headers.common['Authorization'] = `Bearer ${this.access_token}`
            axios.post(`${getBaseURLforBackEnd()}/api/poodle_update_ref1`,datTo,getConfigAxios())
                 .then(()=>{
                     // change front-end
                     // not perform reload

                     const dataMember = this.CBCWorkList.find(dat=>{
                         return dat.idlab === payload.idlab
                     })
                     if(dataMember) {
                         dataMember.ref1 = value
                     }
                     // release
                     this.isFullScreenSearching = false
                 })

                .catch((err)=>{
                    this.$buefy.dialog.alert({
                        title: 'Error',
                        message: `${err.response.data.msg} `,
                        type: 'is-danger',
                        hasIcon: true,
                        icon: 'times-circle',
                        iconPack: 'fa',
                        ariaRole: 'alertdialog',
                        ariaModal: true
                    })
                    this.isFullScreenSearching = false
                })

        },
        editRef1(payload){

           const dataMember = this.CBCWorkList.find(dat=>{
               return dat.idlab === payload.idlab
           })
            if(dataMember){

                // console.log(dataMember.ref1 = "test")

                this.$buefy.dialog.prompt({
                    message: `Input Ref1`,
                    inputAttrs: {
                        placeholder: 'e.g. 1111',
                        maxlength: 10,
                        required: false,
                        value : dataMember.ref1
                    },
                    trapFocus: false,
                    onConfirm: (value) => this.editRef1Real(dataMember,value)
                })


            }

        },
        changeHoldStatus(payload){
               // console.log(payload)
            const dataMember = this.CBCWorkList.find(dat=>{
                return dat.idlab === payload.idlab
            })

            const dataMemberIndex = this.CBCWorkList.indexOf(dataMember)

            this.CBCWorkList[dataMemberIndex].hold = payload.hold ? '1' : null



        },
        showDialogOperations(_data){
            //
            this.propsToDialogOperations = JSON.parse(JSON.stringify(_data))
            this.isDialogOperations = true
        },
        closeDialogOperations(){
                this.isDialogOperations = false
        },
        closeDialogOperationsWithChange(payload){
                // console.log(payload)
                // payload {idlab: "64054647", action: 1, valuetxt: "",care_txt : true/false}
                // find
                const dataMember = this.CBCWorkList.find(dat=>{
                    return dat.idlab === payload.idlab
                })

                const dataMemberIndex = this.CBCWorkList.indexOf(dataMember)

                this.CBCWorkList[dataMemberIndex].ref1 = payload.care_txt ? payload.valuetxt :  this.CBCWorkList[dataMemberIndex].ref1

            if (payload.action === 1){
                    this.CBCWorkList[dataMemberIndex].datetime_accept_ts =DateTime.now().toISO()
                }
                else  if (payload.action === 2){
                    this.CBCWorkList[dataMemberIndex].datetime_cancel_ts =DateTime.now().toISO()
                }
                else  if (payload.action === 3){
                    this.CBCWorkList[dataMemberIndex].datetime_reject_ts =DateTime.now().toISO()
                }
                this.isDialogOperations = false

        },
        async MyJobTrayLabStatus5WantToSwapTabToView(dat){
               // viewLab param id,kindoflab
               //   console.log('MyJobTrayLabStatus5WantToSwapTabToView')

                this.isFullScreenLoading = true
                const datTo = {
                    "idopd": dat.idopd,
                    "user": this.user_id,
                    "ip": this.clientIP
                }
                const vm = this
                await axios.post(`${getBaseURLforBackEnd()}/api/opdinfo_by_hn`, datTo, getConfigAxios())
                    .then(res => {


                            const tmpOPDSelected = {
                                "idopd": res.data.idopd,
                                "idlab": "",
                                "opdname": res.data.name,
                                "type": res.data.species + '(' + res.data.breed + ')',
                                "owner_name": res.data.owner_name,
                                "status": "",
                                "gender": res.data.sex,
                                "age": res.data.age,
                                "kind": "",
                                "automate": "",
                                "datereq": "",
                                "timereq": "",
                                "reqby": "",
                                "dateaccept": "",
                                "timeaccept": "",
                                "acceptby": "",
                                "datecancle": "",
                                "timecancle": "",
                                "cancleby": "",
                                "datereject": "",
                                "timereject": "",
                                "rejectby": "",
                                "dateresult": "",
                                "timeresult": "",
                                "resultby": ""
                            }
                            vm.setupIDOPDTarget(tmpOPDSelected)
                            vm.setupIDLABTarget({"idlab": dat.idlab, "kind": dat.kind})
                            // vm.fetchListOfLab_OPDTarget(dat.idopd)
                            vm.fetchListOfLab_OPDTargetV2(dat.idopd)
                            vm.viewLab(dat.idlab,dat.kind)
                            vm.fetchCountIMR(dat.idopd)
                            vm.$refs.OPDSpace.forceDetailEachLab()
                            vm.isFullScreenLoading = false


                        }
                    )
                    .catch((err) => {
                        if (err.response && err.response.status === 401) {
                            vm.$router.push('/login')
                            vm.isFullScreenLoading = false
                        }
                    })
                    .finally(() => {

                    })




            },
            setInit(){

                // this.filter_selected.date_selected = []
                this.setFilter_date_selected_start(new Date())
                this.setFilter_date_selected_end(new Date())

                this.setFilter_patho_selected(null) // this.filter_selected.patho_selected = null
                this.setFilter_status_selected(null) //this.filter_selected.status_selected = null
                this.docKindAll.length>0 ?     this.filter_selected.docKind_selected = this.docKindAll[0].id :   this.filter_selected.docKind_selected = null
                
                this.setFilter_ownername("")  //this.filter_selected.ownername = ""

                this.setFilter_opdno("") // this.filter_selected.opdno = ""

                this.setFilter_opdname("")  // this.filter_selected.opdname = ""

                this.filter_selected.first = ""
                this.filter_selected.skip = ""

                this.loadCurrentDate(2)

            },


            // testDateCheck(){
            //     console.log(moment(this.date_selected).format("YYYY-MM-DD") )
            // },



            // dateFormatter(dt){
            //     return dt.toLocaleDateString('en-GB');
            // },



            clearSomeField(fieldWantToClear){
                switch(fieldWantToClear) {
                    // date_selected_start
                    // date_selected_due
                    case 'date_selected_start':
                        this.loadCurrentDate(0)
                        break;
                    case 'date_selected_due':
                        this.loadCurrentDate(1)
                        break;
                    case 'patho_selected':
                        this.setFilter_patho_selected(null)
                       // this.filter_selected.patho_selected = null
                        break;
                    case 'status_selected':
                       this.setFilter_status_selected(null) //  this.filter_selected.status_selected = null
                        break;
                    case 'docKind_selected':
                        // this.filter_selected.docKind_selected = null
                        this.docKindAll.length>0 ?     this.filter_selected.docKind_selected = this.docKindAll[0].id :   this.filter_selected.docKind_selected = null
                        break;
                    default:
                        break;
                }
            },
            viewLabEmitBy_ListOfLabEachOPD(payload){
                this.viewLab(payload.id,payload.kindoflab,true)
            },
            viewLab(id,kindoflab){  
                // this.setFlagWantViewLabByHome(forceFlagWantViewLabByHome)
                // console.log("viewLab fire")
                // const dat ={
                //     "idlab" : id,
                //     "kind" : kindoflab
                // }

                this.setupIDLABTarget({
                    "idlab" : id,
                    "kind" : kindoflab
                })

                // The $nextTick() method waits for the DOM to update before executing.
                this.$nextTick(() => {
                       const  tmpOPDTarget = this.CBCWorkList.find(dat=>dat.idlab==id)
                        // console.log(`tmpOPDTarget-->${tmpOPDTarget}`)
                        if (typeof tmpOPDTarget !== 'undefined') {
                                            this.setupIDOPDTarget(
                                                {
                                                    acceptby:"",
                                                    age :tmpOPDTarget.age,
                                                    automate: "",
                                                    cancleby :"",
                                                    date:"",
                                                    dateaccept: "",
                                                    datecancle:"",
                                                    datereject:"",
                                                    datereq:"",
                                                    dateresult:"",
                                                    gender:tmpOPDTarget.sex,
                                                    idlab:"",
                                                    idopd: tmpOPDTarget.idopd ,
                                                    kind: "",
                                                    opdname: tmpOPDTarget.opdname,
                                                    owner_name: tmpOPDTarget.owner_name ,
                                                    rejectby: "",
                                                    reqby: "",
                                                    resultby: "",
                                                    status: "",
                                                    timeaccept: "",
                                                    timecancle : "",
                                                    timereject : "" ,
                                                    timereq : "",
                                                    timeresult: "",
                                                    type : ""
                                                }

                                        )
                        } 
                        
                        
                        
                    
                    
        
                    
                        

                        this.tabMain = 1
                        this.clearListOHistoryOrders()

                        
                        this.fetchListOfLab_OPDTargetV2(this.OPDSelected.idopd)

                        this.$refs.OPDSpace.forceDetailEachLab()
                        this.$buefy.toast.open({
                            duration: 800,
                            message: `Change Lab No to ${id}`,
                            position: 'is-bottom',
                            type: 'is-info'
                        })

                 }); // this.$nextTick

               
                 
                 
                

            },

            doFilterMore(){


                // check date
                // const daysDiff = this.findDiffDate(this.date_selectedStart,this.date_selectedDue)
                const daysDiff = this.findDiffDate(this.filter_date_selected_startModel,this.filter_date_selected_endModel)
                if(daysDiff>31 || daysDiff<0 ){
                    var alarmTxt =   ` `
                    if (daysDiff<0){
                        alarmTxt =   `start date less than due date `
                    }
                    // if(daysDiff>31){
                    //     alarmTxt =   `date over 31 day `
                    // }
                     if(daysDiff>7){
                        alarmTxt =   `date over 7 day `
                    }
                    this.$buefy.dialog.alert({
                        title: 'Error',
                        message: ` Invalid date selected at  ${alarmTxt}  =>  user select at  ${daysDiff}  day`,
                        type: 'is-danger',
                        hasIcon: true,
                        icon: 'times-circle',
                        iconPack: 'fa',
                        ariaRole: 'alertdialog',
                        ariaModal: true
                    })
                    return
                }


                this.skipParamForMainTbl =   this.skipParamForMainTbl +firstSelectParam()
                this.isMoreBtnLoading = true
                const datToFilter = {

                    // "date_selected" :  [moment(this.date_selectedStart).format("YYYY-MM-DD") ,  moment(this.date_selectedDue).format("YYYY-MM-DD") ] ,
                     "date_selected" :  [moment(this.filter_date_selected_startModel).format("YYYY-MM-DD") ,  moment(this.filter_date_selected_endModel).format("YYYY-MM-DD") ] ,
                    // "date_selected" :  [moment(this.filter_selected.date_selected[0]).format("YYYY-MM-DD") ,  moment(this.filter_selected.date_selected[1]).format("YYYY-MM-DD") ] ,
                    "patho_selected" : this.filter_patho_selectedModel, // this.filter_selected.patho_selected,
                    "status_selected" : this.filter_status_selectedModel ,// this.filter_selected.status_selected,
                    "doc_kind" : this.filter_selected.docKind_selected,
                    "ownername": this.filter_ownernameModel, // this.filter_selected.ownername,
                    "opdno":  this.filter_opdnoModel,  // this.filter_selected.opdno,
                    "opdname":  this.filter_opdnameModel, //this.filter_selected.opdname,
                    "first" : firstSelectParam(),
                    "skip" : this.skipParamForMainTbl,
                    "q_datereq" : this.dateKindsSelected
                }

                var vm = this

                // attach access_token it
                axios.defaults.headers.common['Authorization'] = `Bearer ${this.access_token}`
                // fetch
                axios.post(`${getBaseURLforBackEnd()}/api/lablistv3`,datToFilter,getConfigAxios())
                    .then(function (response) {

                         vm.CBCWorkList =   vm.CBCWorkList.concat(response.data)
                         vm.isMoreBtnLoading = false
                         vm.isDisableMoreBtn =  response.data.length === 0
                    })
                    .catch( function(err) {
                        if (err.response && err.response.status === 401) {
                            // console.log('1')
                            vm.$router.push('/login')
                        }
                    })
                    .finally(()=>{
                        // vm.isDisableFilterBtn = false
                        // vm.loadingLnListSpecOPDNo = false
                        // emit data to child (SearchBy)

                        vm.setResultSearchBy( {"date_selected" : moment(this.filter_date_selected_startModel).format("YYYY-MM-DD") + ' to ' + moment(this.filter_date_selected_endModel).format("YYYY-MM-DD")  ,
                            "opd_no":  vm.filter_opdnoModel ,  
                            "opd_name": vm.filter_opdnameModel,  
                            "owner_name": vm.filter_ownernameModel, 
                            "number_of_rec_found": formatNumber( vm.CBCWorkList.length )})

                        // vm.resultSearchBy = {"date_selected" : moment(this.filter_date_selected_startModel).format("YYYY-MM-DD") + ' to ' + moment(this.filter_date_selected_endModel).format("YYYY-MM-DD")  ,
                        //     "opd_no":  vm.filter_opdnoModel , // vm.filter_selected.opdno,
                        //     "opd_name": vm.filter_opdnameModel,  //filter_selected.opdname ,
                        //     "owner_name": vm.filter_ownernameModel, // vm.filter_selected.ownername ,
                        //     "number_of_rec_found": formatNumber( vm.CBCWorkList.length )}


                        vm.isMoreBtnLoading = false

                    })

            },


            doFilter(){

                 
                const vm  = this
                checkAccessTokenWithFpValid(this.fingerPrint)
                    .catch(()=>{
                        vm.$router.push('/login')
                    })

                // check date   
                //  const daysDiff = this.findDiffDate(this.date_selectedStart,this.date_selectedDue)
                const daysDiff = this.findDiffDate(this.filter_date_selected_startModel,this.filter_date_selected_endModel)
                // console.log('diff date --->',daysDiff)
                var alarmTxt =   ` `
                if(this.filter_docKind_selectedModel == 1){
                        if(daysDiff>1){
               
                            if (daysDiff<0){
                                alarmTxt =   `start date less than due date `
                            }
                            if(daysDiff>7){
                                alarmTxt =   `date over 2 day by CBC `
                            }
                            this.$buefy.dialog.alert({
                                title: 'Error',
                                message: ` CBC is not allow diff date over 1 day, Invalid date selected at  ${alarmTxt}  =>  user select at  ${daysDiff+1}  day`,
                                type: 'is-danger',
                                hasIcon: true,
                                icon: 'times-circle',
                                iconPack: 'fa',
                                ariaRole: 'alertdialog',
                                ariaModal: true
                            })
                            return
                        }
                }

                if(daysDiff>7 || daysDiff<0 ){
                    if (daysDiff<0){
                        alarmTxt =   `start date less than due date `
                    }
                     if(daysDiff>7){
                        alarmTxt =   `date over 7 day `
                    }
                    this.$buefy.dialog.alert({
                        title: 'Error',
                        message: ` Invalid date selected at  ${alarmTxt}  =>  user select at  ${daysDiff}  day`,
                        type: 'is-danger',
                        hasIcon: true,
                        icon: 'times-circle',
                        iconPack: 'fa',
                        ariaRole: 'alertdialog',
                        ariaModal: true
                    })
                    return
                }

            //    console.log("doFilter ----> ",this.filter_patho_selectedModel)

               this.setupIDOPDTarget(null)
 
               this.loadingDataLNList = true
               this.isDisableFilterBtn = true
               this.isShowSearchByCompModel = false
               this.selected = null
               this.skipParamForMainTbl = 0
               this.isDisableMoreBtn = false
               // this.takeEmptyListOfLab_OPDTarget()
                this.takeEmptyListOfLab_OPDTarget_v2()
               this.loadingLnListSpecOPDNo = true
               const datToFilter = {

                  
                    "date_selected" :  [
                        DateTime.utc((new Date(this.filter_date_selected_startModel)).getFullYear(), (new Date(this.filter_date_selected_startModel)).getMonth()+1, (new Date(this.filter_date_selected_startModel)).getDate()).toISO()
                        ,
                        DateTime.utc((new Date(this.filter_date_selected_endModel)).getFullYear(), (new Date(this.filter_date_selected_endModel)).getMonth()+1, (new Date(this.filter_date_selected_endModel)).getDate()).toISO()
                       ] ,
                    "patho_selected" : this.filter_patho_selectedModel, //  this.filter_selected.patho_selected,
                    "status_selected" : this.filter_status_selectedModel, //this.filter_selected.status_selected,
                    "doc_kind" :  this.filter_docKind_selectedModel ,// this.filter_selected.docKind_selected,
                    "ownername": this.filter_ownernameModel ,// this.filter_selected.ownername,
                    "opdno":  this.filter_opdnoModel , //this.filter_selected.opdno,
                    "opdname":this.filter_opdnameModel , //filter_selected.opdname,
                    "first" : 10, // firstSelectParam(),
                    "skip" : 0, //this.skipParamForMainTbl,
                    "q_datereq" : this.filter_dateKindsSelectedModel
                }



              
                // console.log(JSON.stringify(datToFilter))  
                axios.defaults.headers.common['Authorization'] = `Bearer ${this.access_token}`
                // fetch
                axios.post(`${getBaseURLforBackEnd()}/api/lablistv3`,datToFilter,getConfigAxios())
                     .then(function (response) {
                        // console.log(response.data)
                        // vm.lnList = response.data
                        vm.setCBCWorkList(response.data)
                        vm.currentPage = 1
                        vm.loadingDataLNList = false
                        vm.isDisableMoreBtn =  response.data.length === 0
                        vm.produceDatGrpUniqs([])
                        vm.produceDatWantToSee([])
                    })
                    .catch( function(err) {

                        vm.$buefy.toast.open({
                            duration: 5000,
                            message: `Some error to ${err}`,
                            position: 'is-top',
                            type: 'is-danger'
                        })
                        vm.loadingLnListSpecOPDNo = false
                        vm.loadingDataLNList = false
                     
                    })
                    .finally(()=>{
                        vm.isDisableFilterBtn = false
                        vm.loadingLnListSpecOPDNo = false
                        // emit data to child (SearchBy)
                        // console.log('this.filter_selected.date_selected[0] ----->',vm.filter_selected)   
                        
                        vm.setResultSearchBy({"date_selected" : moment(vm.filter_date_selected_startModel).format("YYYY-MM-DD") + ' to ' + moment(vm.filter_date_selected_endModel).format("YYYY-MM-DD")  ,
                                              "opd_no":    vm.filter_opdnoModel ,  
                                              "opd_name": vm.filter_opdnameModel , 
                                              "owner_name":  vm.filter_ownernameModel , 
                                              "number_of_rec_found": formatNumber( vm.CBCWorkList.length )})
                        
                        vm.isShowSearchByCompModel = true

                    })


            },


            itemClick(item){
                if(item.data.kind === 2 && !this.pauseItemTreeClick ){
                    // console.log(item.data.id)
                    this.btnNodeTreeEnterPress(item.data.id,item.data.dockind,item.data.idopd)
                }

            },
            saveFavTreeToDB(){
                 if(this.user_id === null){
                    this.$router.push('/login')
                        .catch(()=>{});
                    return
                }

                const vm = this
                this.$buefy.dialog.confirm({
                    message: 'Continue on save favorites?',
                    onConfirm: () => {

                        const datFavTree = {
                            "user_id" : this.user_id,
                            "fav_opd" : this.favTree
                        }
                        axios.post(`${getBaseURLforBackEnd()}/api/upfav_opd`,datFavTree,getConfigAxios())
                        .then(function (response) {
                            vm.$buefy.toast.open({
                                duration: 1000,
                                message: `${response.data.msg}`,
                                position: 'is-bottom',
                                type: 'is-success'
                            })
                        })
                        .finally(()=>{
                            vm.$buefy.toast.open({
                                duration: 2000,
                                message: `Successful save to cloud server`,
                                position: 'is-bottom',
                                type: 'is-success'
                            })
                        })
                    }
                })
            },
            getText_node (arr,id){
                if(Array.isArray(arr)) {

                    arr.forEach((element)=>{
                        if(element.id == id) {
                           this.tmpFolderName = element.text
                        } else {
                            if( Array.isArray(element.children) && element.children.length > 0 ){
                                this.getText_node(element.children,id);
                            }
                        }
                    });
                    return this.tmpFolderName
                }

            } ,
            getDataUnderFolder(arr1,id1){
                var tmpReturn = []
                var found = false;

                function recur(arr,id) {

                    for (var i =0 ; i < arr.length ; i++){
                        if(arr[i].id == id){

                            if((typeof arr[i].children === "undefined")  ){
                                found = true
                                tmpReturn =  []
                                break
                            }else{
                                found = true
                                tmpReturn =  arr[i].children
                                break
                            }

                        }else{
                            if(found){
                               break
                            }else {
                                if (Array.isArray(arr[i].children) && arr[i].children.length > 0) {
                                    recur(arr[i].children, id);
                                }
                            }

                        }
                    }
                }
                recur(arr1,id1)
                return  tmpReturn


            },
            closeDlgEditFolderName(){
                this.isModalEditFolderName = false
            },
            closeDlgEditFolderNameWithChange(changeParam){
                if(changeParam.kind==='r') {
                    this.dataToDelOrRename = changeParam
                    this.renameFolder(this.favTree)
                }else if (changeParam.kind === 'd'){
                    this.removeNode(this.favTree,changeParam.id)
                }
            },
            renameFolder(arr){
                if(Array.isArray(arr)) {
                    arr.forEach(element => {
                        if ((element.kind === 1) && (element.id === this.dataToDelOrRename.id)) {
                            element.text = this.dataToDelOrRename.name
                        } else {
                            if (Array.isArray(element.children) && element.children.length > 0) {
                                this.renameFolder(element.children);
                            }
                        }
                    })
                }


            },
            btnEditPress(_id){
                this.dataToDelOrRename = {
                    id : _id ,
                    name: this.getText_node(this.favTree,_id),
                    kind: "r",
                    dataUnderFolder: this.getDataUnderFolder(this.favTree,_id)
                }
                this.isModalEditFolderName = true
            },
            async btnNodeTreeEnterPress(_id,_dockind,idopd){
               if(this.user_id === null){
                   // console.log(this.user_id)
                   this.$router.push('/login')
                       .catch(()=>{});
                   return
               }
                // console.log(`${_id}   ${_dockind}   ${idopd}`)
                 // console.log("btnNodeTreeEnterPress")
                // console.log(_dockind)
                // console.log(idopd)
               // { "idopd": "58007584", "idlab": "62081956", "opdname": "มะนาว", "type": "สุนัข ( THAI BANGKAEW )", "owner_name": "ลักขณา อารีมิตร", "status": "Result ", "gender": "F", "age": "5 Y 4 M 16 D", "kind": "CBC", "automate": "0", "datereq": "07/11/2019", "timereq": "06:30:47", "reqby": "จุฑามาศ ขอดทอง", "dateaccept": "07/11/2019", "timeaccept": "07:55:31", "acceptby": "คคนางค์ วงศ์ศุภบุตร", "datecancle": "", "timecancle": "", "cancleby": "", "datereject": "", "timereject": "", "rejectby": "", "dateresult": "07/11/2019", "timeresult": "08:33:58", "resultby": "" }
               // fake idopd selected
               const datTo = {
                   "idopd": idopd,
                   "user":  this.user_id,
                   "ip":    this.clientIP
               }
               const vm = this
               this.isFullScreenSearching = true

               axios.post(`${getBaseURLforBackEnd()}/api/opdinfo_by_hn`,datTo,getConfigAxios())
                   .then(res=>{
                       // console.log('btnNodeTreeEnterPress fire')

                        vm.selected = {
                            "idopd": res.data.idopd,
                            "idlab": _id,
                            "opdname": res.data.name,
                            "type": res.data.species+'('+res.data.breed+' )' ,
                            "owner_name" : res.data.owner_name ,
                            "status": "" ,
                            "gender": res.data.sex ,
                            "age": res.data.age ,
                            "kind": _dockind,
                            "automate": "",
                            "datereq": "",
                            "timereq": "",
                            "reqby": "",
                            "dateaccept": "",
                            "timeaccept": "",
                            "acceptby": "",
                            "datecancle": "",
                            "timecancle": "",
                            "cancleby": "",
                            "datereject": "",
                            "timereject": "",
                            "rejectby": "",
                            "dateresult": "",
                            "timeresult": "",
                            "resultby": ""
                        }
                       vm.isFullScreenSearching = false
                   })
                   .catch(err=>{
                       // console.log(err)
                       if (err.response && err.response.status === 401) {
                           vm.$router.push('/login')
                           // console.log('6')
                       }
                   })
                   .finally(()=>{
                       vm.isFullScreenSearching = false
                   })

               // and view lab

               this.viewLab(_id ,_dockind)

            },
            btnRemovePress(_id){
                 // prevent itemClick
                 this.pauseItemTreeClick = true
                 // release it after 1 second
                 setTimeout(()=>{
                     this.pauseItemTreeClick = false // release
                 },1000)
                 this.dataToDelOrRename = {
                    id : _id ,
                    name: this.getText_node(this.favTree,_id),
                    kind: "d",
                    dataUnderFolder: this.getDataUnderFolder(this.favTree,_id)
                }
                this.isModalEditFolderName = true


             },
            removeNode (arr,id){
                 if(Array.isArray(arr)) {
                    arr.map((element,idx)=>{
                        if(element.id == id) {
                            arr.splice(idx,1);
                        } else {
                            if( Array.isArray(element.children) && element.children.length > 0 ){
                                this.removeNode(element.children,id);
                            }
                        }
                    });
                }

            } ,
            resetTree(){
                 if (this.favTree.length>0) {
                     this.$buefy.dialog.confirm({
                         title: 'Deleting Favorites  ?',
                         message: 'Are you sure you want to <b>delete</b> your favorite? This action cannot be undone.',
                         confirmText: 'Delete',
                         type: 'is-danger',
                         hasIcon: true,
                         onConfirm: () => this.favTree = []
                     })
                 }
            },
            logResizeTree(e) {
                this.panTreeSize = e[0].size
                localStorage.setItem('panTreeSize', e[0].size)
            },
            logResizeMain(e) {
                this.panTableMasterDataSize =  e[0].size
                localStorage.setItem('panTableMasterDataSize', e[0].size)
            },
            getRandomInt() {
                return Math.floor(Math.random() * (1000 - 5 + 1)) + 5
            },
            addFolder() {
                const tmpID = genUUID(10)
                const tmpName = 'New Folder'
                this.favTree.push( {
                    "id": tmpID,
                    "text": tmpName ,
                    "opened" : true ,
                    "children": [],
                    "selected": true,
                    "kind" : 1 ,// folder,
                    "dropDisabled": false,
                })
                this.$buefy.toast.open({
                    duration: 500,
                    message: `Add New Folder`,
                    position: 'is-bottom',
                    type: 'is-success'
                })
            },
            showDlgConfirmToAddOPDToFav(){
                this.isModalDlgConfirmToAddOPDToFav = true
            },
            closeDlgConfirmToAddOPDToFav(){
                this.isModalDlgConfirmToAddOPDToFav = false
            },
            closeDlgConfirmToAddOPDToFav_WithChange(dataToFav){
                 // add to favTree
                // console.log(dataToFav)
                 dataToFav.forEach( element => {
                     var tmpGender = element.gender === 'F' ? 'Female' : 'Male'
                     this.favTree.push( {
                        "id": element.idlab ,
                        "idopd":  element.idopd ,
                        "dockind": element.kind ,
                        "text": 'LN : '+'  '+element.idlab+ ' / ' + element.opdname+'('+element.idopd+')   ' + ' / ' + element.owner_name + ' / '+ tmpGender+' ',
                        "icon": "fa fa-paw",
                        "dropDisabled": true,
                        "kind" : 2 // opd
                    })
                })
            },
            loadFavTree(){
                // test
                const  vm = this
                    axios.get(`${getBaseURLforBackEnd()}/api/fav_opd/${this.user_id}` ,getConfigAxios())
                    .then( response => {
                        this.favTree  =  response.data.dat
                    })
                    .catch(function (error) {
                        if (error.response) {
                            vm.$buefy.toast.open({
                                duration: 500,
                                message: error.response.data.dat,
                                position: 'is-bottom',
                                type: 'is-warning'
                            })
                        }
                    })
            },
            loadCurrentDate(type_){
                    const vm = this

                    if(type_ === 0){
                        getCurrentDate()
                        .then(res=>{
                            vm.filter_date_selected_startModel = new Date( Date.parse(res))
                        })
                        .catch(error=>{
                            vm.$buefy.toast.open({
                                            duration: 500,
                                            message:  `${error}`,
                                            position: 'is-bottom',
                                            type: 'is-warning'
                              })
                        })
                        // vm.date_selectedStart = new Date( Date.parse(tmp))
                    }else if(type_ === 1){
                        getCurrentDate()
                            .then(res=>{
                                vm.filter_date_selected_endModel = new Date( Date.parse(res))
                            })
                            .catch(error=>{
                                vm.$buefy.toast.open({
                                    duration: 500,
                                    message:  `${error}`,
                                    position: 'is-bottom',
                                    type: 'is-warning'
                                })
                            })
                        // vm.date_selectedDue = new Date( Date.parse(tmp))
                    }else {
                        getCurrentDate()
                            .then(res=>{
                                vm.filter_date_selected_startModel = new Date( Date.parse(res))
                                vm.filter_date_selected_endModel = new Date( Date.parse(res))
                            })
                            .catch(error=>{
                                vm.$buefy.toast.open({
                                    duration: 500,
                                    message:  `${error}`,
                                    position: 'is-bottom',
                                    type: 'is-warning'
                                })
                            })

                    }
            }



        },
        watch : {
 
            selected :{
                handler: function(val){

                    if(val) {
                        if(!this.isDialogOperations){
                        // console.log("watch fire")

                        this.setupIDOPDTarget(val)
                        //
                        // structor of opd_selected
                        //
                        // opd_selected={
                        //     acceptby:"",
                        //     age :"",
                        //     automate: "",
                        //     cancleby :"",
                        //     date:"",
                        //     dateaccept: "",
                        //     datecancle:"",
                        //     datereject:"",
                        //     datereq:"",
                        //     dateresult:"",
                        //     gender:"",
                        //     idlab:"",
                        //     idopd:"" ,
                        //     kind: "",
                        //     opdname: "",
                        //     owner_name: "" ,
                        //     rejectby: "",
                        //     reqby: "",
                        //     resultby: "",
                        //     status: "",
                        //     timeaccept: "",
                        //     timecancle : "",
                        //     timereject : "" ,
                        //     timereq : "",
                        //     timeresult: "",
                        //     type : ""
                        // }
                        this.setupIDLABTarget( {
                            "idlab" : val.idlab,
                            "kind" : val.kind
                        })
                        // clear CBC table
                        this.$refs.OPDSpace.dataRawCBC=[]
                        this.$refs.OPDSpace.chartXAxis=[]
                        this.$refs.OPDSpace.chartYAxis=[]
                        this.$refs.OPDSpace.columnsCUS1.splice(3)
                        this.loadingLnListSpecOPDNo = true
                        this.$refs.OPDSpace.fetchCountIMR(val.idopd)
                        // this.$refs.OPDSpace.getCountIMR(val.idopd)
                        const vm = this
                        // check access token
                        checkAccessTokenWithFpValid(this.fingerPrint)
                            .catch(()=>{
                                vm.$router.push('/login')
                                // console.log('7')
                            })


                


                        this.fetchListOfLab_OPDTargetV2(val.idopd)
                            .then(() => {
                                vm.loadingLnListSpecOPDNo = false
                            })

                        this.$refs.OPDSpace.forceDetailEachLab()


                        }
                     

                    }
                    if(val === null){
                        this.setupIDLABTarget( {
                            "idlab" : null,
                            "kind" : null
                        })

                        this.setupIDOPDTarget(null)
                    }



                },
                // immediate : true
            }

        },
        mixins :[labStatusColor,userRoleFind,findDiffDate,dateFormatterForDatePicker,getISO8601ToYearMonthDate],


    }
</script>



<style scoped>
    .small-text {
        font-size: 9px;
    }


    #btn-item-tree-delete{
        opacity: 0.7;
        color: red;
    }

    #btn-item-tree-enter{
        opacity: 0.7;
        color: cornflowerblue;
    }


    #btn-item-tree-edit{
        opacity: 0.5;
        color: darkgreen;
    }
    .total_check_label{
        color: blue;
    }

    /*.b-datepicker{*/
    /*z-index: 9999;!*Changed this css property which was 100 prior*!*/
    /*position: absolute;*/
    /*display: none;*/
    /*top: 0;*/
    /*left: 0;*/
    /*width: 17em;*/
    /*background-color: #b7c6b2;*/
    /*border-bottom: 1px solid #000;*/
    /*border-right: 1px solid #000;*/
    /*margin: 0;*/
    /*padding: 1px 1px 2px 2px;*/
    /*}*/

    /*#btnClear1 , #btnClear2  , #btnClear3 , #btnClear4 , #btnClear5 , #btnClear6 , #btnClear7 {*/
    /*    opacity: 0;*/
    /*}*/

    /*#btnClear1:hover , #btnClear2:hover  , #btnClear3:hover , #btnClear4:hover , #btnClear5:hover , #btnClear6:hover , #btnClear7:hover {*/
    /*   opacity: 1;*/
    /*}*/

</style>



